<template>
  <VRow justify="center">
    <!--//todo uncomment when Google and FB auth will be done-->
    <template v-if="false">
      <VCol class="px-2 pb-4" md="12">
        <span class="body-1">
          {{ $t("authForm.continueWith") }}
        </span>
      </VCol>
      <VCol class="px-2 pt-0" md="6" cols="12" sm="12" xs="12">
        <VBtn
          large
          class="w-100 border-radius-8 box-shadow-elevation-4"
          color="textWhite"
        >
          <span class="mr-3">
            <img
              :src="
                require('@slg/web-customer-shared/src/assets/img/google-logo.svg')
              "
              :alt="$t('imageAlt.googleLogo')"
            />
          </span>
          <span class="button"> Google </span>
        </VBtn>
      </VCol>
      <VCol class="px-2 pt-0" md="6" cols="12" sm="12" xs="12">
        <VBtn
          large
          class="w-100 border-radius-8 box-shadow-elevation-4"
          color="textWhite"
        >
          <span class="mr-3">
            <img
              :src="
                require('@slg/web-customer-shared/src/assets/img/facebook-logo.svg')
              "
              :alt="$t('imageAlt.facebookLogo')"
            />
          </span>
          <span class="button"> Facebook </span>
        </VBtn>
      </VCol>
    </template>
    <VCol class="px-2 pb-2" md="12">
      <span class="body-1">
        <!--//todo uncomment when Google and FB auth will be done-->
        <!--        {{ $t('authForm.orUsePhone') }}-->
        <!--//todo Remove when Google and FB auth will be done-->
        {{ $t("authForm.usePhone") }}
      </span>
    </VCol>
    <VCol class="px-2 pt-0 pb-0" cols="12" col="12" @keyup.enter="onSubmit">
      <!-- todo: default country must be approved by BA -->
      <vue-tel-input-vuetify
        ref="phoneInput"
        aria-required="true"
        :value="typeof phone === 'string' ? phone : ''"
        v-phone-restrict
        data-test="phoneFieldAuth"
        :defaultCountry="location"
        :placeholder="$t('authForm.enterPhoneNumber')"
        :label="$t('authForm.phoneNumber')"
        :error="isValiadationMessageShow && !isFormValid"
        :errorMessages="
          isValiadationMessageShow && !isFormValid
            ? $t('validations.phoneIncorrect')
            : ''
        "
        disabledFetchingCountry
        @input="onPhoneInput"
        @country-changed="countryChanged"
      />
    </VCol>
    <VCol class="px-2 pt-0" cols="12" col="12">
      <VBtn
        class="w-100 border-radius-8"
        data-test="loginActionButton"
        dark
        large
        color="brandingPrimary"
        :disabled="isNextBlocked"
        :class="{ disabled: isNextBlocked }"
        @click="onSubmit"
      >
        <span class="button">
          {{ $t("general.next") }}
        </span>
      </VBtn>
    </VCol>
  </VRow>
</template>

<script lang="ts">
export default {
  name: 'StartStep',
};
</script>

<script setup lang="ts">
import { computed, onActivated, onMounted, ref } from 'vue';
import { phoneFromTelInput } from '@slg/web-customer-shared/src/utils/telInput';
import { isCaptchaEnabled, isCaptchaVerified, prepareCaptcha } from '../../utils/turnstile';

defineProps({
  location: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(['checkPhone']);

const phone = ref<any>(null);
const isValiadationMessageShow = ref(false);
const isLoading = ref(false);
const phoneInput = ref<any>(null);

const getPhoneObject = computed(() => phoneInput.value?.phoneObject);
const isFormValid = computed(() => typeof phone.value === 'string' && !!phone.value && getPhoneObject.value?.isValid);
const isNextBlocked = computed(() => isCaptchaEnabled() && !isCaptchaVerified.value);

function verifyCaptcha() {
  prepareCaptcha().catch(() => undefined);
}

onMounted(verifyCaptcha);
onActivated(verifyCaptcha);

function onPhoneInput(value: unknown) {
  phone.value = phoneFromTelInput(value);
}

function countryChanged() {
  const dialCode = getPhoneObject.value?.country?.dialCode;
  if (dialCode) {
    phone.value = `+${dialCode}`;
  }
}

async function onSubmit() {
  if (isNextBlocked.value) {
    return;
  }
  isValiadationMessageShow.value = true;
  if (isFormValid.value) {
    emit('checkPhone', getPhoneObject.value.number.e164);
  }
}
</script>